import React, { useState } from 'react';
import { object, string } from 'yup';

import MESSAGES from '../../../locales';
import { Form, Input, Button } from '../../_shared';
import { isEnterprise } from '../../../config';

const SignInSchema = object().shape({
  email: string()
    .max(200, MESSAGES['email.invalid'])
    .email(MESSAGES['email.invalid'])
    .required(MESSAGES['email.presence']),
  password: string().required(MESSAGES['password.presence']),
});

const SignInForm = (props) => {
  const [role, setRole] = useState('student');

  return (
    <Form schema={SignInSchema} onSubmit={props.onSubmit}>
      <h3 className="mb-6 text-3xl text-center font-bold tracking-widest leading-7">
        Log In
      </h3>

      <Input
        id="email"
        name="email"
        type="email"
        label="Your e-mail"
        placeholder="johnsmith@mail.com"
        autoComplete="off"
        required
      />
      <div className="mb-5"></div>
      <Input
        id="password"
        name="password"
        label="Password"
        placeholder="***************"
        type="password"
        required
      />
      {/* <div className="mt-5 field-label">Log in as</div>
      <div className="-my-5">
        <RadioGroup
          name="role"
          value={role}
          options={[
            { label: 'Manager', key: 'manager' },
            { label: 'Student', key: 'student' },
          ]}
          onChange={setRole}
        />
      </div> */}
      <div className="flex flex-col w-full m-auto mt-12">
        <Button
          type="misc"
          className={`w-full font-semibold py-2 px-4 border border-solid rounded-lg text-white bg-primary`}
          caption="Log In"
          busy={props.busy}
        />
      </div>
      <div className="mt-4 flex flex-col items-center">
        <a
          className="no-underline font-bold cursor-pointer text-black text-base"
          href="https://www.adventuresincre.com/accelerator/"
          target="_blank"
          rel="noreferrer"
        >
          <span className="text-gray-200 font-semibold">
            Don&apos;t have an account?
          </span>{' '}
          Sign up
        </a>
        <a
          className="mt-3 no-underline font-bold cursor-pointer text-black text-base"
          href={
            isEnterprise
              ? '/forgot-password'
              : 'https://www.adventuresincre.com/password-reset/'
          }
          target={isEnterprise ? '_self' : '_blank'}
          rel="noreferrer"
        >
          Forgot password?
        </a>
      </div>
    </Form>
  );
};

export default SignInForm;
